export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  isSending: (state) => state.isSending,
  response: (state) => state.response,
  balances: (state) => state.balances,
};
